import { combineReducers } from 'redux';
import restaurant from './restaurant/reducer';
import user from './user/reducer';
import order from './order/reducer';

const reducers = combineReducers({ restaurant, user, order });

export default reducers;
